import Modal from "components/DesignSystem/Modal/Modal";
import { Button } from "components/DesignSystem/Button/Button";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { pluralize } from "utils/pluralize";

type MoreFilingsWaitingModalProps = {
  open: boolean;
  entityName: string;
  filingCount: number;
  onLater: () => void;
  onReviewPay: () => void;
};

export const MoreFilingsWaitingModal = ({
  open,
  entityName,
  filingCount,
  onLater,
  onReviewPay,
}: MoreFilingsWaitingModalProps) => (
  <Modal.Root open={open} onOpenChange={(next) => !next && onLater()}>
    <Modal.Content useCustomOverlay size="small">
      <StatusModal
        type="warning"
        title="You've got more filings waiting"
        showCloseButton={false}
      >
        <p className="t-mt-3 t-text-body-sm t-text-text-30">
          {entityName} has {pluralize(filingCount, "filing", "filings")}{" "}
          detected. It&apos;s best to complete these along with your current
          checkout to avoid missing deadlines.
        </p>
      </StatusModal>

      <Modal.Footer className="t-flex t-justify-end t-gap-2">
        <Button type="button" customType="secondary" onClick={onLater}>
          I&apos;ll do it later
        </Button>
        <Button type="button" customType="primary" onClick={onReviewPay}>
          Review &amp; pay
        </Button>
      </Modal.Footer>
    </Modal.Content>
  </Modal.Root>
);
